export default __webpack_public_path__ + "check.3be56bd4.svg";